import { KVCameraView } from './KVCameraView'

export class KVSceneSettings {
  startingView: KVCameraView | null

  constructor() {
    this.startingView = null
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVSceneSettings {
    const kvSettings = new KVSceneSettings()
    if (json.startingView)
      kvSettings.startingView = KVCameraView.fromJSON(json.startingView)
    return kvSettings
  }

  static toJSON(kvSettings: KVSceneSettings): any {
    const json: any = {}
    if (kvSettings.startingView) {
      json.startingView = KVCameraView.toJSON(kvSettings.startingView)
    }
    return json
  }
}
